import { EntityApi } from "../../services/ApiPlatform";

export abstract class SchoolBatchApi extends EntityApi {
    protected static GET_COLLECTION = "/api/school-batches";

    protected static POST_COLLECTION = "/api/school-batches";

    protected static GET_ITEM = "/api/school-batches/{id}";

    protected static PUT_ITEM = "/api/school-batches/{id}";

    protected static PATCH_ITEM = "/api/school-batches/{id}";

    protected static DELETE_ITEM = "/api/school-batches/{id}";
}
